<template>
  <CContainer class="d-flex content-center min-vh-100">
    <CRow>
      <CCol>
        <CCardGroup>
          <CCard class="p-5">
            <CCardBody>
              <CForm>
                <h1>Login</h1>
                <p class="text-muted">Sign In to your account</p>
                <CInput
                  placeholder="Email"
                  autocomplete="email"
                  @change="handleEmail"
                  @keyup.enter="handleLogin"
                >
                  <template #prepend-content>
                    <CIcon name="cil-user" />
                  </template>
                </CInput>
                <CInput
                  placeholder="Password"
                  :type="typePassword"
                  autocomplete="curent-password"
                  @input="handlePassword"
                  @keyup.enter="handleLogin"
                >
                  <template #prepend-content>
                    <CIcon name="cil-lock-locked" />
                  </template>
                  <template #append>
                    <CButton color="secondary" @click="changeTypePassword">{{
                      textButton
                    }}</CButton>
                  </template>
                </CInput>
                <p class="alert-login" v-if="!credentialLogin">
                  Email or Password Incorrect
                </p>
                <CRow>
                  <CCol col="6" class="text-left">
                    <CButton color="primary" class="px-4" @click="handleLogin"
                      >Login</CButton
                    >
                  </CCol>
                </CRow>
              </CForm>
            </CCardBody>
          </CCard>
        </CCardGroup>
      </CCol>
    </CRow>
  </CContainer>
</template>

<script>
import axios from "axios";
import jwt from "jsonwebtoken";
import Swal from "sweetalert2";

export default {
  name: "Login",
  data() {
    return {
      credential: {
        email: "",
        password: "",
      },
      typePassword: "password",
      textButton: "show",
      credentialLogin: true,
      domain: process.env.VUE_APP_DOMAIN_URL,
      token: "Bearer " + localStorage.getItem("token"),
    };
  },
  mounted() {
    const data = jwt.decode(localStorage.getItem("token"));
    if (data === null) {
      console.log(true);
    } else {
      axios
        .get(`${this.domain}/v1/account/${data.account_id}`, {
          headers: {
            Authorization: this.token,
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          // JSON responses are automatically parsed.
          this.$router.push({ path: `/` });
          this.accountData = response.data;
        })
        .catch((e) => {
          this.$router.push({ path: `/pages/login` });
          console.log(e);
        });
    }
  },
  computed: {
    fields() {
      return [
        { key: "key", label: this.username, _style: "width:150px" },
        { key: "value", label: "", _style: "width:150px;" },
      ];
    },
  },
  methods: {
    handleEmail(event) {
      this.credential.email = event;
      this.credentialLogin = true;
    },
    handlePassword(event) {
      this.credential.password = event;
      this.credentialLogin = true;
    },
    changeTypePassword() {
      this.typePassword =
        this.typePassword === "password" ? "text" : "password";
      this.textButton = this.textButton === "show" ? "hide" : "show";
    },
    handleLogin() {
      axios
        .post(`${this.domain}/v1/account/auth/login`, this.credential, {
          headers: {
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          // JSON responses are automatically parsed.

          const accountData = jwt.decode(response.data.token);
          Swal.fire({
            icon: "success",
            title: `Welcome ${accountData.username}`,
            showConfirmButton: false,
            timer: 2000,
          });
          localStorage.setItem("token", response.data.token);
          localStorage.setItem(
              "isRestrictedCorporate",
              accountData.account_id === 1215 ? "true" : "false"
          );
          this.$router.push({ path: `/` });
        })
        .catch((e) => {
          if (e.response === undefined) {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Network Error",
            });
          } else {
            this.credentialLogin = false;
          }
        });
    },
  },
};
</script>
<style>
.alert-login {
  color: red;
}
</style>
